// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Warranty: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve" fill="currentColor">
<path d="M12,23.91c-0.39,0-0.7-0.31-0.7-0.7V1.5c-4.71,0.22-7.35,2.57-8,3.23v7c0,5.37,4.72,8.67,7.53,10.15l-0.65,1.24
	C7.68,21.81,1.9,18.07,1.9,11.74V4.46c0-0.16,0.06-0.32,0.16-0.45C2.19,3.86,5.38,0.09,12,0.09c0.39,0,0.7,0.31,0.7,0.7v21.29
	c2.31-1.16,8-4.62,8-10.44V4.68c-0.62-0.62-2.99-2.73-7.19-3.16l0.14-1.39c5.51,0.55,8.17,3.69,8.29,3.83
	c0.1,0.13,0.16,0.28,0.16,0.45v7.23c0,7.66-8.2,11.49-9.65,12.1C12.34,23.85,12.18,23.91,12,23.91z"/>
</svg>;
};

export default React.memo(Warranty);
